import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/secondadmin/base.component';

@Component({
  selector: 'app-newtheme',
  templateUrl: './newtheme.component.html',
  styleUrls: ['./newtheme.component.css']
})
export class NewthemeComponent extends BaseComponent implements OnInit {
  them_id: any;
  headers = "Add";

  constructor(
  ) {
    super();
  }

  ngOnInit() {
    this.activatedRoute.queryParams
      .subscribe(params => {
        this.them_id = params.them_id;
      });
    //get item details using id
    if (this.them_id) {
      this.headers = "Edit"
    }
  }
  
}
